const TemplateActionType = {
  CREATE_CUSTOM_TEMPLATE: 'CREATE_CUSTOM_TEMPLATE',

  GET_CUSTOM_TEMPLATES: 'GET_CUSTOM_TEMPLATES',

  SAVE_TEMPLATES: 'SAVE_TEMPLATES',
  SAVE_TEMPLATES_TOTAL: 'SAVE_TEMPLATES_TOTAL',

  RESET_TEMPLATES: 'RESET_TEMPLATES',

  DELETE_CUSTOM_TEMPLATE: 'DELETE_CUSTOM_TEMPLATE',
  EDIT_CUSTOM_TEMPLATE: 'EDIT_CUSTOM_TEMPLATE',
};

export default TemplateActionType;
